interface PaginationProps {
  current: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) {
    return (
      <div className="mt-8 flex items-center justify-center text-sm text-foreground-500">
        共 1 页 · 已显示全部结果
      </div>
    );
  }

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <nav className="mt-8 flex items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        aria-label="上一页"
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300/60 text-foreground-800 hover:border-accent-400 hover:text-accent-300 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-lg" aria-hidden="true" />
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          aria-current={page === current ? "page" : undefined}
          className={`w-9 h-9 flex items-center justify-center rounded-md text-sm transition-colors cursor-pointer ${
            page === current
              ? "bg-primary-500 text-background-50"
              : "border border-background-300/60 text-foreground-700 hover:border-accent-400 hover:text-accent-300"
          }`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, current + 1))}
        disabled={current === totalPages}
        aria-label="下一页"
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300/60 text-foreground-800 hover:border-accent-400 hover:text-accent-300 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-lg" aria-hidden="true" />
      </button>
    </nav>
  );
}